import { KnownScript, KnownScriptData } from './types';

export const KNOWN_SCRIPT_DATA_MAP: Record<KnownScript, KnownScriptData> = {
	[KnownScript.GOOGLE_IDENTITY_SERVICES]: {
		elementId: 'script-gsi',
		url: () => `https://accounts.google.com/gsi/client`,
	},
};
